








import store from './store';
import HeaderBar from './components/HeaderBar/HeaderBar.vue';
import ConfirmationModal from './components/ConfirmationModal/ConfirmationModal.vue';
import APIService from './services/APIService';
import AuthenticationService from './services/AuthenticationService';

export default {
  components: {
    HeaderBar,
    ConfirmationModal,
  },
  async mounted() {
    if (await AuthenticationService.isTokenExpired()) return;
    const user = await APIService.getMyUser();
    store.commit('setUser', {
      id: user.id,
      username: user.username,
      roles: user.roles,
      employeeId: user.employeeId,
    });
  },
};
